import { render } from "./RoundLiveInfo.vue?vue&type=template&id=5c35ae92"
import script from "./RoundLiveInfo.vue?vue&type=script&lang=js"
export * from "./RoundLiveInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__